import { ReactNode } from "react";
import styled from "styled-components";
import { useToken } from "../Context/useToken";
import { fontStyles } from "../style/common_font";
import { RowView2 } from "../style/common_style";
import Admin_menubar from "./Admin_menubar";

const Container = styled(RowView2)`
  width: 100%;
  height: 100vh;
  ${fontStyles.regular}
  &.gray {
    background-color: #f8f8f8;
  }
`;
const ConBox = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
  div.children {
    flex: 1;
    padding: 1.5rem;
    border-top: 1px solid #f0f0f0;
    overflow: auto;
    padding-top: 30px;
  }
`;
const Topbar = styled(RowView2)`
  width: 100%;
  height: 3rem;
  min-height: 3rem;
  background-color: white;
`;
const Btn = styled.div`
  padding: 0.5rem 1.5rem;
  margin-right: 1rem;
  ${fontStyles.medium}
  text-align: center;
  color: #858585;
  border: 1px solid #dddddd;
  border-radius: 4px;
  cursor: pointer;
`;

interface Layout {
  children: ReactNode;
  menuname: string;
}

const Layout_Admin = (props: Layout) => {
  const { logout } = useToken();
  const { children } = props;
  const menuname = props.menuname;
  const isDash = menuname === "대시보드" ? "gray" : "";

  return (
    <Container className={`${isDash} top`}>
      <Admin_menubar menuname={menuname} />

      <ConBox>
        <Topbar className="end">
          <Btn onClick={() => logout("ok")}>로그아웃</Btn>
        </Topbar>

        <div className="children">{children}</div>
      </ConBox>
    </Container>
  );
};

export default Layout_Admin;
